import { parseQueryString, replaceQueryString } from "@client/lib/api";
import { isShallowEqual } from "@client/lib/object";
import { isNull, isUndefined } from "lodash";
import { type CourseDetail } from "./types";

export const pushUrlState = (state: CourseDetail.UrlState) => {
  const currentState = getUrlState();
  if (isShallowEqual(currentState, state)) return;

  const params = Object.keys(state).reduce((res, x) => {
    if (isNull(state[x]) || isUndefined(state[x])) {
      delete res[x];
    } else {
      res[x] = state[x];
    }
    return res;
  }, parseQueryString());

  window.history.pushState("{}", "", replaceQueryString(window.location.href, params));
};

export const getUrlState = (): CourseDetail.UrlState => {
  const qs = parseQueryString(window.location.search) || {};
  return {
    ...qs,
    cid: qs.cid ? qs.cid : undefined,
    csid: qs.csid ? qs.csid : undefined,
    cscid: qs.cscid ? qs.cscid : undefined
  };
};

export const findSection = (course: CourseDetail.CourseAppState, lessonId: string): CourseDetail.CourseModule => {
  const section = course.lessons.find((x) => x.id === lessonId)!;

  return course.modules.find((s) => s.id === section.moduleId)!;
};

export const mapToCourseAppState = (
  activeCourse: CourseDetail.ClientCourse | null,
  isMembership: boolean
): CourseDetail.CourseAppState | null => {
  if (!activeCourse) return null;

  return {
    course: activeCourse.course,
    modules: activeCourse.modules,
    lessons: activeCourse.lessons,
    activeLessonId: isMembership ? null : activeCourse.activeLesson?.id ?? null,
    allFaq: activeCourse.allFaq,
    activeModuleId: isMembership ? null : activeCourse.activeLesson?.lesson.moduleId ?? null
  };
};
